import { TColumnName } from "../types";
import { Camera } from "plotly.js";

export const generatePCACacheKey = (datasetName: string, method: TColumnName) =>
  `${datasetName}_${method}`;

export const generateScoresCacheKey = (
  datasetName: string,
  AName: TColumnName,
  BName: TColumnName
) => `${datasetName}_${AName}_${BName}`;

export const isCameraPreset = (
  camera: Partial<Camera> | undefined,
  cameraPreset: Camera
) => {
  if (!camera) {
    return false;
  }

  return (
    camera.eye?.x === cameraPreset.eye.x &&
    camera.eye?.y === cameraPreset.eye.y &&
    camera.eye?.z === cameraPreset.eye.z &&
    camera.center?.x === cameraPreset.center.x &&
    camera.center?.y === cameraPreset.center.y &&
    camera.center?.z === cameraPreset.center.z &&
    camera.up?.x === cameraPreset.up.x &&
    camera.up?.y === cameraPreset.up.y &&
    camera.up?.z === cameraPreset.up.z
  );
};

export const deepClone = (obj: Record<any, any>) =>
  JSON.parse(JSON.stringify(obj));
